import React from "react";
import Card from "../../../../core/Card";
import Typography from "../../../../core/Typography";
import Button from "../../../../core/Button";
import Checkbox from "../../../../core/CheckBox";
import Input from "../../../../core/Inputs/DefaultInput";
import { useDevice } from "../../../customHooks";
import { useEffect, useRef, useState } from "react";
import style from "../../../style.module.css";
// routes
import { Link } from "react-router-dom";
import Title from "../Title";
import Axios from "axios";

// import Header from "../../survey/survey-form/landing-page/widgets/Header";
import Svg from "../../../../component/Svg";

import { toast } from 'react-toastify';



export const ForgetPasswordConfirmation = () => {
  let device = useDevice();
  const [isOpen, setOpen] = useState(false);
  const inputRef = useRef();
  const [count, setCount] = useState(0);
  const [isChecked, setChecked] = useState(false);

  const [timer, setTimer] = useState(600); 
  const [timerStarted, setTimerStarted] = useState(false);

  useEffect(() => {
    if (!timerStarted) {
      const interval = setInterval(() => {
        setTimer(prevTimer => (prevTimer === 0 ? 600 : prevTimer - 1)); // Decrement timer every second
      }, 1000);
      // setTimerStarted(true);
      // Clear interval on component unmount or route change
      return () => clearInterval(interval);
    }
  }, [timerStarted]);

  const formatTimer = (timeInSeconds) => {
    const minutes = Math.floor(timeInSeconds / 60);
    const seconds = timeInSeconds % 60;
    const formattedMinutes = minutes < 10 ? `0${minutes}` : minutes;
    const formattedSeconds = seconds < 10 ? `0${seconds}` : seconds;
    return `${formattedMinutes}:${formattedSeconds}`;
  };


  useEffect(() => {
    const str = String(inputRef?.current?.props.value)?.length;
    setCount(str);
  }, []);
  const handleCount = e => {
    setCount(String(e.target.value).length);
  };
  const [otp, setOtp] = useState('');

  const urlParams = new URLSearchParams(window.location.search);
  let email = urlParams.get('email');

  React.useEffect(() => {
    if (email == null) {
      window.location = '/ForgotPassword';
    }
  });

  const verifyOtp = (props) => {
    //console.log(process.env.REACT_APP_NODE_API_URL, 'process.env.REACT_APP_NODE_API_URL')
    // Axios.post(process.env.REACT_APP_NODE_API_URL + "/users/forgetPasswordOtpCheck", {
    Axios.post(process.env.REACT_APP_NODE_API_URL + "/users/verify-fp-otp", {
      email: email,
      otp: otp,
    }).then((response) => {
      // console.log(response)
      if (response.data.statusCode == 200) {
        toast.success(response.data.msg);
        window.location = '/admin/reset-password?email=' + email;
      } else if (response.data.statusCode !=200) {
        toast.error(response.data.msg);
      }
     });


  }

  const otpResend = () => {
    setTimerStarted(false);
    let payload = {
      email: email,
    }
    //console.log(payload, "payload");
    // dispatch(resendOtp(payload))
    // console.log(dispatch(resendOtp(payload)))
    // console.log(process.env.REACT_APP_NODE_API_URL)
    Axios.post(process.env.REACT_APP_NODE_API_URL+"/users/forgetPasswordOtpSend", {
      email: email
    })
      .then((response) => {
        // Check the response status and handle accordingly
        if (response.status === 200) {
            toast.success(response.data.msg);
        } else {
          //alert("Unable to sign up");
          toast.error("Unable to send. Please try again later.");
        }
      })
      .catch((error) => {
        //console.error("Error signing up:", error);
        // alert("Unable to sign up. Please try again later.");
        toast.error("Unable to send. Please try again later.");
      });
  }

  return (
    <>
      <div className='d-flex flex-column site-main-wrapper login-page'>

        <div className="flex-grow-1 main-content-wrap d-flex align-items-center justify-content-center">
          <div className="container">
            <div className="form-outer-wrapper">
              <div className="logo-wrap text-center">
                <Link to="/#0t" className='home-logo'>
                  <Svg name="logo" />
                </Link>
              </div>
              <div className="form-wrapper">
                <div className="form-heading text-center">
                  <h3>Let us know it’s you</h3>
                  <p> Enter  OTP sent on your email <span className="black">{email}</span> to verify it's you.</p>
                </div>
                <div className="field-wrapper">
                  <div className="mb__20 position-relative"> {/* Add Class error to this div once error occurs and if its valid, add class success*/}
                    < Input
                      ref={inputRef}
                      type='text'
                      view='outlined'
                      dense={false}
                      color='default'
                      label=''
                      placeholder='Enter OTP'
                      clearButton={true}
                      success={false}
                      error={false}
                      fill={true}
                      errorHelperText={null}
                      className={"formsinput"}
                      value={otp}
                      name="otp"
                      onInput={e => setOtp(e.target.value)}
                      maxLength={6}
                    />
                  </div>
                  <div className="additional-info d-flex justify-content-between mb__20 pt-1">
                    <div className="text-primary">
                      <Typography
                        type="caption"
                        fill={true}
                        color="primary"
                        colorStep={60}
                        tagName="div"
                      >
                        {/* <b> 00:30</b> */}
                        <b className={timerStarted ? "d-none" : "d-block"}>  {formatTimer(timer)}</b>
                      </Typography>
                    </div>
                    <a href="#1" disabled>
                      <Typography
                        type="caption"
                        fill={true}
                        colorStep={60}
                        tagName="div"
                      >
                        {/* <b> Resend code</b> */}
                        <b  onClick={otpResend} className={timerStarted ? "text-primary" : "text-secondary"} > Resend code</b>
                      </Typography>
                    </a>
                  </div>
                </div>
                <div className="button-wrap">
                  <Button className={"formsbutton mb-0"}
                    type="default"
                    view="filled"
                    color="primary"
                    text="Done"
                    fill={true}
                    // onClick={() => setOpen(true)}
                    onClick={verifyOtp}
                  />
                </div>
                {/* <div className="form-text text-center">
                  <p>Wrong email address? <Link to="/ForgotPassword"> Change it</Link></p>
                </div> */}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ForgetPasswordConfirmation;
